<template>
  <custom-dialog width="900px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <custom-table
        ref="table"
        row-key="funcId"
        type="checkbox"
        tableCode="menuAssociateFunc"
        :tree-props="{ children: 'children', hasChildren: 'children[0]' }"
        v-model="tableSelect"
        :data="menuFuncTree"
        @select="onFuncSelect"
        @selectionAll="onFuncSelectionAll"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveMenuFunc">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableSelect: [],
      appId: '',
      menuId: '',
      menuFuncTree: [],
      funcParentMap: {},
      formSearch: {
        appId: ''
      }
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.appId = this.model.data.appId;
      this.menuId = this.model.data.menuId;
      this.getFuncTree();
    },
    // 获取功能列表
    getFuncTree: function () {
      this.formSearch.appId = this.appId;
      this.$getJSON(apis.MenuDisAsFunc, this.formSearch).then((res) => {
        this.menuFuncTree = res.data;
        this.setFuncParentMap();
      });
    },
    // 切换页
    onCurrentPage: function () {
      this.getFuncTree();
    },
    // 切换每页数量
    onSizeChange: function () {
      this.getFuncTree();
    },
    // 切换功能勾选
    onFuncSelect: function (selection, row) {
      const checked = selection.some(item => item.funcId === row.funcId);
      this.setChildrenSelection(row.children, checked);
      if (!checked) {
        this.setParentSelection(row, checked);
      }
    },
    // 表头全选时，同步整棵树的勾选状态
    onFuncSelectionAll: function (selection) {
      const checked = !!selection.length;
      this.setChildrenSelection(this.menuFuncTree, checked);
    },
    // 设置子级勾选状态
    setChildrenSelection: function (children, checked) {
      (children || []).forEach((item) => {
        this.setRowSelection(item, checked);
        this.setChildrenSelection(item.children, checked);
      });
    },
    // 设置单行勾选状态
    setRowSelection: function (row, checked) {
      if (!this.$refs.table || !this.$refs.table.$refs.tb1) {
        return;
      }
      this.$refs.table.$refs.tb1.toggleRowSelection(row, checked);
    },
    // 设置父级勾选状态
    setParentSelection: function (row, checked) {
      const parent = this.funcParentMap[row.funcId];
      if (!parent) {
        return;
      }
      this.setRowSelection(parent, checked);
      this.setParentSelection(parent, checked);
    },
    // 缓存功能父子级关系
    setFuncParentMap: function () {
      this.funcParentMap = {};
      this.setChildrenParent(this.menuFuncTree);
    },
    // 递归缓存功能父子级关系
    setChildrenParent: function (children, parent) {
      (children || []).forEach((item) => {
        if (parent) {
          this.funcParentMap[item.funcId] = parent;
        }
        this.setChildrenParent(item.children, item);
      });
    },
    // 获取表格当前选中数据
    getTableSelection: function () {
      const table = this.$refs.table && this.$refs.table.$refs.tb1;
      if (table && table.store && table.store.states) {
        return table.store.states.selection || [];
      }
      return this.tableSelect;
    },
    // 获取选中数据及其子级
    getRowsWithChildren: function (rows) {
      const rowMap = {};
      (rows || []).forEach((item) => {
        this.setRowWithChildren(item, rowMap);
      });
      return Object.keys(rowMap).map(key => rowMap[key]);
    },
    // 递归收集当前行及其子级
    setRowWithChildren: function (row, rowMap) {
      if (!row || rowMap[row.funcId]) {
        return;
      }
      rowMap[row.funcId] = row;
      (row.children || []).forEach((item) => {
        this.setRowWithChildren(item, rowMap);
      });
    },
    // 保存菜单功能绑定
    saveMenuFunc: function () {
      const selectedRows = this.getRowsWithChildren(this.getTableSelection());
      const funcIds = selectedRows.filter(t => t.funcTypeCode !== 'fuc_module').map(f => f.funcId);
      if (!funcIds.length) {
        this.$message.error(this.$t('base_menu_func_dialog.qxzyggnbd'));
        return;
      }
      this.$postJSON(
        apis.MenuFuncAs,
        {
          funcIds: funcIds,
          menuId: this.menuId
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss"></style>
